import { createContext, useContext, useEffect, useState } from 'react'
import { APIs } from 'services/apis'

interface MaintenanceContextProps {
  isMaintenance: boolean | null
}

const MaintenanceContext = createContext<MaintenanceContextProps>({
  isMaintenance: null
})

export const MaintenanceProvider = ({ children }: any): React.ReactElement => {
  const [isMaintenance, setIsMaintenance] = useState<boolean | null>(null)

  useEffect(() => {
    const fetchFlag = async (): Promise<void> => {
      const res = await APIs.getMaintenanceMode()
      setIsMaintenance(res.isSystemUnderMaintenance)
    }
    fetchFlag()
  }, [])

  return (
    <MaintenanceContext.Provider value={{ isMaintenance }}>
      {children}
    </MaintenanceContext.Provider>
  )
}

export const useMaintenance = (): MaintenanceContextProps => useContext(MaintenanceContext)
